class ChatDefinition {
  constructor(id, data, options) {
    this.id = id
    this.data = data || {}
    this.options = options || {}
  }
}

export default ChatDefinition
